// extracted by mini-css-extract-plugin
export var subtitle = "_bo-2";
export var title = "_bo-0";
export var titleNoWrap = "_bo-1";